import React from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import { icons } from '../../utils/icons';
import classNames from 'classnames';

export default function NewFormHeader(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div
      className={classNames(classes.dialog_header, props.containerClassName)}>
      {props.title && (
        <label htmlFor='title' className={classes.dialog_label}>
          {props.title}
        </label>
      )}
      <img
        className={classes.close_icon}
        src={props.closeIcon ? props.closeIcon : icons(theme).closeIcon}
        alt=''
        onClick={props.onNewClose}
      />
    </div>
  );
}
